import { ref, readonly } from 'vue';

import { fetchSelfServiceCreditDetail } from '@/api/apiService';

const _isVisibleModalCreditHistory = ref(false); // 모달이 보이는지

export const useModalCreditHistory = () => {
  const isVisibleModalCreditHistory = readonly(_isVisibleModalCreditHistory);

  const openModalCreditHistory = async () => {
    const { data } = await fetchSelfServiceCreditDetail(null, null);
    if (!data || data.datas.length === 0) return;
    _isVisibleModalCreditHistory.value = true;
  };

  const closeModalCreditHistory = () => {
    _isVisibleModalCreditHistory.value = false;
  };

  return {
    isVisibleModalCreditHistory,
    openModalCreditHistory,
    closeModalCreditHistory,
  };
};
